import React from 'react';
import CaptureDisposition from './components/CaptureDisposition';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css'; // ← keep this (base styles)

function App() {
  return (
    <div className="app-container">
      <Authenticator
        signUpAttributes={[]}
        hideSignUp={true}
        loginMechanisms={['username']}
        formFields={{
          signIn: {
            username: {
              label: 'Username',
              placeholder: 'Enter your username',
            },
          },
        }}
        // variation="default"           // or try "modal" if you prefer
        components={{
          // Completely replace the header
          Header: () => (
            <div className="auth-header">
              <img 
                src="/flagship_logo.png" 
                alt="Flagship Logo" 
                className="app-logo"
              />
              <h1 className="auth-title">Flagship - Login</h1> {/* optional */}
            </div>
          ),
        }}
      >
        {({ signOut, user }) => (
          <div className="App">
            <CaptureDisposition user={user} signOut={signOut} />
          </div>
        )}
      </Authenticator>
    </div>
  );
}

export default App;